"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCurrency = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Select_1 = require("./Select");
const Input_1 = require("../Common/Input");
exports.SelectCurrency = (_a) => {
    var { className, inputProps, selectProps, children } = _a, props = tslib_1.__rest(_a, ["className", "inputProps", "selectProps", "children"]);
    return (React.createElement("div", Object.assign({ className: `clp-select-currency ${className}` }, props),
        React.createElement(Input_1.Input, Object.assign({}, inputProps)),
        React.createElement(Select_1.Select, Object.assign({}, selectProps), children)));
};
//# sourceMappingURL=SelectCurrency.js.map